import schema from "./template-pages-schema.json" with { type: "json" };
export { schema as templateSchema };
export const text = (value, fallback = "", limit = 80) =>
  typeof value === "string" && value.trim() ? value.trim().slice(0, limit) : fallback;
export const pageUrl = (value) => {
  const raw = text(value).replace(/^#/, "");
  return /^[\p{L}\p{N}_-]+$/u.test(raw) ? `#${raw}` : "";
};
export function normalizeTemplatePages(value, authoritative = false) {
  const rows = Array.isArray(value) ? value : [];
  const builtins = schema.pages
    .filter((base) => !authoritative || base.id === "home" || rows.some((p) => p?.id === base.id))
    .map((base) => {
      const raw = Array.isArray(value) ? value.find((page) => page?.id === base.id) : null;
      return {
        id: base.id,
        kind: "builtin",
        url: pageUrl(raw?.url) || `#${base.id}`,
        name: text(raw?.name, base.name),
        title: text(raw?.title, base.title),
        layout: base.layouts.includes(raw?.layout) ? raw.layout : base.layouts[0],
        enabled: base.id === "home" || raw?.enabled !== false,
        navigation: base.navigation && raw?.navigation !== false,
        sort: Number.isFinite(Number(raw?.sort))
          ? Math.max(1, Math.floor(Number(raw.sort)))
          : base.sort,
        columns: [1, 2, 3].includes(raw?.columns) ? raw.columns : base.columns,
        gap: [8, 12, 16, 20].includes(raw?.gap) ? raw.gap : base.gap,
        blocks: base.blocks
          .filter(
            (block) =>
              !authoritative || block.locked || raw?.blocks?.some((b) => b.id === block.id),
          )
          .map((block) => {
            const setting = Array.isArray(raw?.blocks)
              ? raw.blocks.find((b) => b?.id === block.id)
              : null;
            return {
              id: block.id,
              componentId: text(setting?.componentId, `CMP-${base.id}-${block.id}`),
              enabled: block.locked || setting?.enabled !== false,
              sort: Number.isFinite(Number(setting?.sort))
                ? Math.max(1, Math.floor(Number(setting.sort)))
                : block.sort,
            };
          })
          .concat(
            (Array.isArray(raw?.blocks) ? raw.blocks : [])
              .filter((b) => b?.componentId && !base.blocks.some((known) => known.id === b.id))
              .map((b, i) => ({
                id: text(b.id, `BLOCK-${i + 1}`),
                componentId: text(b.componentId),
                enabled: b.enabled !== false,
                sort: Number(b.sort) || base.blocks.length + i + 1,
              })),
          )
          .sort((a, b) => a.sort - b.sort),
      };
    })
    .sort((a, b) => a.sort - b.sort);
  const custom = rows
    .filter((p) => p?.id && !schema.pages.some((base) => base.id === p.id))
    .slice(0, 100)
    .map((raw, index) => ({
      id: text(raw.id),
      kind: "custom",
      url: pageUrl(raw.url) || pageUrl(raw.name) || `#page-${index + 1}`,
      name: text(raw.name, "新页面"),
      title: text(raw.title, text(raw.name, "新页面")),
      layout: "component-page",
      enabled: raw.enabled !== false,
      navigation: false,
      sort: Math.max(1, Number(raw.sort) || builtins.length + index + 1),
      columns: [1, 2, 3].includes(raw.columns) ? raw.columns : 2,
      gap: Math.min(48, Math.max(0, Number(raw.gap) || 12)),
      blocks: (Array.isArray(raw.blocks) ? raw.blocks : [])
        .slice(0, 100)
        .map((b, i) => ({
          id: text(b.id, `BLOCK-${i + 1}`),
          componentId: text(b.componentId),
          enabled: b.enabled !== false,
          sort: Math.max(1, Number(b.sort) || i + 1),
        }))
        .sort((a, b) => a.sort - b.sort),
    }));
  return [...builtins, ...custom].sort((a, b) => a.sort - b.sort);
}
export function normalizeTemplateTheme(value) {
  const color = (key) => (/^#[a-f0-9]{6}$/i.test(value?.[key]) ? value[key] : schema.theme[key]);
  return { accent: color("accent"), surface: color("surface") };
}
